import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetScanTunnelQueryVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;


export type GetScanTunnelQuery = { __typename?: 'Query', scanTunnel: { __typename?: 'ScanTunnel', id: string, name: string, mode: Types.ScanTunnelMode, container_type_id?: number | null } };


export const GetScanTunnelDocument = gql`
    query getScanTunnel($id: ID!) {
  scanTunnel(id: $id) {
    id
    name
    mode
    container_type_id
  }
}
    `;

/**
 * __useGetScanTunnelQuery__
 *
 * To run a query within a React component, call `useGetScanTunnelQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScanTunnelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScanTunnelQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetScanTunnelQuery(baseOptions: Apollo.QueryHookOptions<GetScanTunnelQuery, GetScanTunnelQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetScanTunnelQuery, GetScanTunnelQueryVariables>(GetScanTunnelDocument, options);
      }
export function useGetScanTunnelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetScanTunnelQuery, GetScanTunnelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetScanTunnelQuery, GetScanTunnelQueryVariables>(GetScanTunnelDocument, options);
        }
export type GetScanTunnelQueryHookResult = ReturnType<typeof useGetScanTunnelQuery>;
export type GetScanTunnelLazyQueryHookResult = ReturnType<typeof useGetScanTunnelLazyQuery>;
export type GetScanTunnelQueryResult = Apollo.QueryResult<GetScanTunnelQuery, GetScanTunnelQueryVariables>;